<template>
  <div>
    <div class="body">
      <div class="border">
        <div class="title">报 告 摘 要</div>
        <div class="txt">
          <p style="text-indent: 2em; padding: 20px">
            概要包括气质类型、学科兴趣指数、职业兴趣指数以及门类适合度排序。
            将你的个性特征与学习各种专业所需要具备的特质进行对比后，应用心理测量方法评估出的你学习各个专业的适合情况，分数越高，意味着你在该专业上可发展性越强。通俗而言，专业适合度指数意味着：
            从你的兴趣、气质类型、性格特征来看，你更适合学习哪些专业。
          </p>
          <div class="n_title">专业适合度排序</div>
          <table style="width: 100%" class="tables1">
            <tr>
              <td style="text-align: center">排名</td>
              <td style="text-indent: 2rem">专业门类</td>
              <td style="text-align: center">适合指数</td>
            </tr>
            <tr v-for="(item, i) in zhuanye" :key="i">
              <td style="text-align: center">{{ i + 1 }}</td>
              <td style="text-indent: 2rem">{{ item.BigClassName }}</td>
              <td style="text-align: center">{{ item.MaxFen }}</td>
            </tr>
          </table>
          <div class="n_title">你的特质剖析</div>
          <div class="right">
            <span>低</span><span>较低</span><span>中等</span><span>较高</span><span>高</span>
          </div>
          <div v-for="(item, i) in tzpx.Trait" :key="i">
            <div>
              <div style="display: inline-block; width: 40%">
                {{ item.Trait }}
              </div>
              <div style="display: inline-block; width: 56%">
                <el-progress :text-inside="true" :stroke-width="15" :format="format" :percentage="Number(item.TotalPoints * 4)"></el-progress>
              </div>
            </div>
          </div>
          <div class="n_title">学科兴趣</div>
          <div>
            下面这份课程偏好柱状图符合你的喜好吗？以下分数仅代表喜好程度，不代表成绩好坏。
          </div>
          <div>
            <span style="font-weight: bold; margin-right: 100px">学科兴趣</span>
            <span style="margin-right: 100px">低</span><span style="margin-right: 100px">|</span>
            <span style="margin-right: 100px">中</span>
            <span style="margin-right: 100px">|</span> <span>高</span>
          </div>
          <div v-if="xkxq">
            <div v-for="(item, keys) in xkxq" :key="keys">
              <div>
                <div style="display: inline-block; width: 20%">
                  {{ item.Subject }}
                </div>
                <div style="display: inline-block; width: 70%">
                  <el-progress :text-inside="true" :stroke-width="20" :percentage="Number(item.Points)"></el-progress>
                </div>
              </div>
            </div>
          </div>
          <div v-if="tzpx.KeyWord">
            <div class="n_title">人格性质</div>
            <div style="font-weight: bold">
              你的气质：{{ tzpx.Temperament }}
            </div>
            <div style="display: inline-block;
    padding: 0 17px;
    background: #c4a7e9;
    color: white;
    border-radius: 30px;
    font-size: 12px;
    line-height: 20px;
    margin-right:15px
}" v-for="(item, keyss) in tzpx.KeyWord.split('|')" :key="keyss">
              {{ item }}
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  props:['zhuanye','tzpx','xkxq'],
  name: "",
  
  
  
  methods: {
    format(item) {
      return item / 4;
    },
  },
};
</script>

<style scoped lang='less'>
.content {
  max-width: 800px;
  margin: 0 auto;
}
.main {
  .home_page {
    background-image: linear-gradient(#8950d5, #bb85e7);
    color: white;
    overflow: hidden;
    margin-bottom: 30px;
  }
  .body {
    padding: 20px;
  }
  .border {
    padding: 20px;
    padding-bottom: 40px;
    border: 1px solid #c4a7e9;
    position: relative;
    margin-top: 57px;
    .title {
      position: absolute;
      top: -23px;
      left: 276px;
      height: 41px;
      width: 200px;
      background: #c4a7e9;
      text-align: center;
      line-height: 40px;
      color: white;
    }
  }

  .tables {
    border: 1px solid #c4a7e9;
  }

  .line div {
    padding: 6px;
    font-weight: bold;
    background-color: #ffffff;
  }
  .l {
    float: left;
  }
  .r {
    float: right;
    margin-bottom: 0px;
  }
}
.n_title {
  display: inline-block;
  text-indent: 2rem;
  position: relative;
  left: -21px;
  background: #c4a7e9;
  color: white;
  margin-top: 90px;
  margin-bottom: 20px;
  width: 300px;
}
.right {
  display: inline-block;
  width: 400px;
  span {
    width: 20%;
    text-align: center;
    display: inline-block;
  }
}
.txt {
  line-height: 30px;
}
#chart {
  width: 500px;
  height: 500px;
  margin: 100px auto 0;
}
.tables1 {
  margin-top: 10px;
  border-collapse: collapse;
  td {
    border: 1px solid rgb(173, 169, 169);
  }
}
.print {
  position: fixed;
  bottom: 100px;
  right: 200px;
}
</style>
